import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";

function SelectContext() {
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [form, setForm] = useState({
    fy: "2026",
    company: "1", // static company id
    branch: "4",
    branch_name: "Mirqab",
  });
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    loadBranches(1);
  }, []);

  const loadBranches = async (companyId) => {
    try {      
      const res = await api.get(`/loadbranches/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBranches(res.data.data);
    } catch (err) {
      console.error("Error loading branches", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // If branch changes, find the name
    if (name === "branch") {
      const selected = branches.find((b) => String(b.id) === value);
      setForm({
        ...form,
        branch: value,
        branch_name: selected ? selected.name : "",
      });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.fy || !form.company || !form.branch) {
      alert("Please select all fields.");
      return;
    }

    // store per window
    sessionStorage.setItem("selectedContext", JSON.stringify(form));

    // navigate with state (so TopBar updates instantly)
    navigate("/dashboard", { state: { context: form } });
  };

  return (
    <div className="container d-flex col-6 justify-content-center align-items-center vh-100">
      <div className="card p-4 shadow-lg w-100"> {/* style={{ maxWidth: "500px" }} */}
        <h4 className="text-center mb-4">Select Company, Branch & Financial Year</h4>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Financial Year</label>
            <select
              className="form-select"
              name="fy"
              value={form.fy}
              onChange={handleChange}
            >
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Company</label>
            <select
              className="form-select"
              name="company"
              value={form.company}
              onChange={handleChange}
            >
              <option value="1">Hub Business Center</option>
            </select>
          </div>

          <div className="mb-5">
            <label className="form-label">Branch</label>
            <select
              className="form-select"
              name="branch"
              value={form.branch}
              onChange={handleChange}
            >
              {branches.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          </div>

          <div className="text-center">
            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
              {loading ? "Loading..." : "Continue to Dashboard"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SelectContext;